export type RootState = {
  auth: any;
  settings: any;
  tickets: any;
  upload: any;
  files: any;
  annoucements: any;
};

// export const CONFIG_ENDPOINT_BASE = "https://cdn.maxhospitals.in/medi-ui/crm/";
const data = localStorage.getItem("config");
const allData = JSON.parse(data || "{}");
export const BASE_API_URL =
  allData?.BASE_API_URL || "https://incapi-cipla-dev.azurewebsites.net/api/v1/"; //"https://maxalpha-medi.maxhospitals.in/vault/v1/";
export const BASE_API_URL_BETAMEDI = allData?.BASE_API_URL_2 || "";
export const BASE_SOCIAL_API_URL =
  allData?.BASE_SOCIAL_API_URL || "https://betasocialapi.hlthclub.in/vault/v1/";
export const BASE_WEB_URL = allData?.BASE_WEB_URL; //"https://maxalpha-medi.maxhospitals.in/";
export const BASE_WEB_URL_CRM =
  allData?.BASE_WEB_URL_CRM || "https://betacrm.hlthclub.in/"; //"https://maxalpha-medi.maxhospitals.in/";
export const GLOBAL_LIST_LIMIT = allData?.GLOBAL_LIST_LIMIT; //25;
export const ACCOUNT_PREFIX: string = allData?.ACCOUNT_PREFIX || "ciplanew"; //"max";
export const SENTRY_INIT_NAME: string = allData?.SENTRY_INIT_NAME; //"max-ui";
export const CLIENT_NAME: string = allData?.CLIENT_NAME || "ciplanew"; //"Max";
export const APPLICATION_NAME: string = allData?.APPLICATION_NAME || ""; //"Max Hospitals";
export const ENABLE_NOTIFICATION: boolean = allData?.ENABLE_NOTIFICATION; //true;
export const ENABLE_WEB_SOCKET: boolean = allData?.ENABLE_WEB_SOCKET; //true;
export const ADD_TOKEN_BASE_URL: boolean = allData?.ADD_TOKEN_BASE_URL; //true;

export const TNC_URL: string = allData?.TNC_URL; //
// "https://cdn.maxhospitals.in/terms_conditions/max_tnc.html";
export const PRIVACY_POLICY_URL: string = allData?.PRIVACY_POLICY_URL; //
// "https://cdn.maxhospitals.in/terms_conditions/max_privacy_policy.html";
export const SENTRY_INIT_DSN: string = allData?.SENTRY_INIT_DSN; //
// "https://3faba4cf081140be9d341f3e55afd2aa@o1090269.ingest.sentry.io/6274274";
export const CHAT_BASE_URL: string = allData?.CHAT_BASE_URL; //"https://alphawebsocket.maxhospitals.in/";
export const WEBSOCKET_END_POINT: string = allData?.WEBSOCKET_END_POINT; //
// "wss://o6a1gv6qc8.execute-api.ap-south-1.amazonaws.com/dev";
export const SERVICE_LIST = allData?.SERVICE_LIST;
// [
//   // {name: 'book_appointment'},
//   { name: "order_medicines" },
// ];
export const TICKET_APPOINTMENT_ASSOCIATION: boolean =
  allData?.TICKET_APPOINTMENT_ASSOCIATION; //true;
export const LOGO_URL: string = allData?.LOGO_URL; //true;

export const GOOGLE_MAP_API = "AIzaSyDuaDg-vPiU5qfaPr1ZM3t3ldMuRP_IsHc";
export const TRANSLATION_KEY = allData?.TRANSLATION_KEY || "en";
export const MSAL_CLIENT_ID =
  allData?.MSAL_CLIENT_ID || "d6560d63-9651-4fe2-ac6f-215aad20d64a";
export const MSAL_TENANT_ID =
  allData?.MSAL_TENANT_ID || "e6fd9f9f-6c49-4254-b8e8-90fba073cceb"; // "0336464a-c425-408c-a568-15c3416a24b8";
export const MAX_COGNITO_REFRESH_TIMES = 24;

export const PERMISSIONS = {
  READ_TICKET: "task_module.actions.read_ticket",
  MANAGER_VIEW: "employee_portal_module.actions.manager_view",
  ADMIN_VIEW: "employee_portal_module.actions.admin_view",
  FILE_CONFIGURATION: "employee_portal_file_management_module.actions.upload_file_read",
  AUDIENCE_CONFIG: "employee_portal_announcement_module.actions.audience_config",
  ANNOUNCEMENT_CONFIG: "employee_portal_announcement_module.actions.announcement_config",
  USER_ANNOUNCEMENT_LIST: "employee_portal_announcement_module.actions.announcement_listing",
};
